jQuery(document).ready(function($) {
  let $formNewsletterPromoEmails = $('form#newsletter_promo_emails'),
      $formUserData = $('form#user-data'),
      $formAddresses = $('form#update-adresses'),
      $formDeleteAccount = $('form#delete-user');

  $formAddresses.on('submit', function(e) {
    e.preventDefault();

    let billing_gender = $formAddresses.find('select#billing_gender').val(),
        billing_first_name = $formAddresses.find('input#billing_first_name').val(),
        billing_last_name = $formAddresses.find('input#billing_last_name').val(),
        billing_email = $formAddresses.find('input#billing_email').val(),
        billing_address_1 = $formAddresses.find('input#billing_address_1').val(),
        billing_address_2 = $formAddresses.find('input#billing_address_2').val(),
        billing_postcode = $formAddresses.find('input#billing_postcode').val(),
        billing_city = $formAddresses.find('input#billing_city').val(),
        billing_country = $formAddresses.find('div#billing_country_field select').val(),
        billing_phone = $formAddresses.find('input#billing_phone').val();

    let shipping_gender = $formAddresses.find('select#shipping_gender').val(),
        shipping_first_name = $formAddresses.find('input#shipping_first_name').val(),
        shipping_last_name = $formAddresses.find('input#shipping_last_name').val(),
        shipping_address_1 = $formAddresses.find('input#shipping_address_1').val(),
        shipping_address_2 = $formAddresses.find('input#shipping_address_2').val(),
        shipping_postcode = $formAddresses.find('input#shipping_postcode').val(),
        shipping_city = $formAddresses.find('input#shipping_city').val(),
        shipping_country = $formAddresses.find('div#shipping_country_field select').val();

    $formAddresses.find('.field-error').remove();
    $formAddresses.find('.response').remove();
    $formAddresses.find('button').prop('disabled', true);
    $formAddresses.find('button').append('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'update-addresses',
        'billing_gender': billing_gender,
        'billing_first_name': billing_first_name,
        'billing_last_name': billing_last_name,
        'billing_email': billing_email,
        'billing_address_1': billing_address_1,
        'billing_address_2': billing_address_2,
        'billing_postcode': billing_postcode,
        'billing_city': billing_city,
        'billing_country': billing_country,
        'billing_phone': billing_phone,
        'shipping_gender': shipping_gender,
        'shipping_first_name': shipping_first_name,
        'shipping_last_name': shipping_last_name,
        'shipping_address_1': shipping_address_1,
        'shipping_address_2': shipping_address_2,
        'shipping_postcode': shipping_postcode,
        'shipping_city': shipping_city,
        'shipping_country': shipping_country,
      }
    }).done( function (response) {
      $formAddresses.find('button').prop('disabled', false);
      $formAddresses.find('button i').remove();

      if (response.is_error) {
        let errors = response.errors;

        $.each(errors, function (i, data) {
          let target = data.target,
              message = data.message;

          $formAddresses.find('#' +  target).after('<p class="field-error">' + message + '</p>');
        });
      } else {
        let $containerAddresses = $('div#container-addresses');

        $containerAddresses.find('.billing_data').html(response.billing_data);
        $containerAddresses.find('.shipping_data').html(response.shipping_data);
        $formAddresses.parent().scrollTop(0);
        $formAddresses.prepend('<p class="response">' + response.message + '</p>');
      }
    });
  });

  $formNewsletterPromoEmails.on('submit', function(e) {
    e.preventDefault();

    let newsletter_data = $formNewsletterPromoEmails.find('select:nth(0)').val(),
        promos_data = $formNewsletterPromoEmails.find('select:nth(1)').val();

    $formNewsletterPromoEmails.find('.response').remove();
    $formNewsletterPromoEmails.find('button').prop('disabled', true);
    $formNewsletterPromoEmails.find('button').append('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'update-newsletters-promos-settings',
        'newsletter': newsletter_data,
        'promos': promos_data,
      }
    }).done( function (response) {
      let $newsletterPromosContainer = $('div#container-newsletter-promos'),
          newsletter_data = response.newsletter_data,
          promos_data = response.promos_data;

      $newsletterPromosContainer.parent().scrollTop(0);
      $newsletterPromosContainer.find('.newsletter-data').html(newsletter_data);
      $newsletterPromosContainer.find('.promos-data').html(promos_data);
      $formNewsletterPromoEmails.prepend('<p class="response">' + response.message + '</p>');
      $formNewsletterPromoEmails.find('button').prop('disabled', false);
      $formNewsletterPromoEmails.find('button i').remove();
    });
  });

  $formUserData.on('submit', function (e) {
    e.preventDefault();

    let gender = $formUserData.find('select#gender').val(),
        first_name = $formUserData.find('input#first_name').val(),
        last_name = $formUserData.find('input#last_name').val(),
        email = $formUserData.find('input#email').val(),
        phone = $formUserData.find('input#phone').val();

    $formUserData.find('.response').remove();
    $formUserData.find('button').prop('disabled', true);
    $formUserData.find('button').append('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'update-user-data',
        'gender': gender,
        'first_name': first_name,
        'last_name': last_name,
        'email': email,
        'phone': phone
      }
    }).done( function (response) {
      let $formUserDataContainer = $('div#container-user-data');

      $formUserDataContainer.find('.user-name').html(response.name_data);
      $formUserDataContainer.find('.user-email').html(response.email_data);
      $formUserDataContainer.find('.user-phone').html(response.phone_data);

      $formUserData.parent().scrollTop(0);
      $formUserData.prepend('<p class="response">' + response.message + '</p>');
      $formUserData.find('button').prop('disabled', false);
      $formUserData.find('button i').remove();
    });
  });

  $formDeleteAccount.on('submit', function (e) {
    e.preventDefault();

    $formDeleteAccount.find('.response').remove();
    $formDeleteAccount.find('button').prop('disabled', true);
    $formDeleteAccount.find('button').append('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'delete-account',
      }
    }).done( function (response) {
      if (response.is_error) {
        $formDeleteAccount.prepend('<p class="response">' + response.message + '</p>');
        $formDeleteAccount.find('button').prop('disabled', false);
        $formDeleteAccount.find('button i').remove();
      } else {
        document.location.href = '/';
      }
    });
  });

});
